const Message = () => ({
  required: {
    text: (field) => `${field} is required.`,
    select: (field) => `Please select ${field}.`,
  },
  min: {
    string: (min, field) =>
      `${field} should contain minimum ${min} characters.`,
    select: (min, field) => `Please select minimum ${min} ${field}.`,
    numeric: (min, field) => `${field} should contain minimum ${min} digits.`,
  },
  max: {
    string: (max, field) =>
      `${field} should contain maximum ${max} characters.`,
    select: (max, field) => `Please select maximum ${max} ${field}.`,
    numeric: (max, field) => `${field} should contain maximum ${max} digits.`,
  },
  email: () => `Invalid email.`,
  regex: {
    password: (field) =>
      `${field} should contain at least an uppercase letter a lowercase letter a number and a special character.`,
    numeric: () => `Please enter digits only.`,
    decimal: (number) =>
      `Please enter digits or decimal digits upto ${number} decimal only.`,
    other: (field) => `Please enter valid ${field}.`,
  },
  global: {
    networkIssue: "Network Issue!",
    internalServer: "Internal Server Error",
    notFound: "Not Found",
    unauthorize: "You are unauthorized to perform this action.",
  },
  between: {
    numeric: (field, min, max) =>
      `The ${field} must be between ${min} and ${max}.`,
  },
  url: `Invalid URL.`,
  only_digit: "Only digit allow",
  space_not_allowed: "Space is not allow",
  only_string: "Only string allow",
  successMessage: (val) => `${val} Successfully`,
  string_with_special_char: (field) =>
    `${field} must start/end with a letter. Only letters, space, -, ', and . allowed.`,
  consent_message: "Please check the box to confirm your consent.",
});

export default Message;
